import { render, staticRenderFns } from "./QuickEntrys.vue?vue&type=template&id=7063b063&scoped=true"
import script from "./QuickEntrys.vue?vue&type=script&lang=js"
export * from "./QuickEntrys.vue?vue&type=script&lang=js"
import style0 from "./QuickEntrys.vue?vue&type=style&index=0&id=7063b063&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063b063",
  null
  
)

export default component.exports